import OfferContactDialogForm from '@/components/Dialog/OfferContactDialogForm';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { Button } from '@eye-able/ui';
import { SendIcon } from 'lucide-react';

export function GovernanceActivationContactButton() {
  const { t } = useInlineTranslation();

  return (
    <OfferContactDialogForm
      product={t('governance')}
      trigger={
        <Button variant='yellow'>
          <SendIcon aria-hidden />
          {t('contactUsToActivate')}
        </Button>
      }
    />
  );
}
